const FileTypes = [
    {
        mime: 'image/jpeg',
        ext: 'jpg',
        icon: 'Image'
    }, {
        mime: 'image/png',
        ext: 'png',
        icon: 'Image'
    }, {
        mime: 'text/csv',
        ext: 'csv',
        icon: 'ListAlt'
    }, {
        mime: 'application/vnd.oasis.opendocument.spreadsheet',
        ext: 'ods',
        icon: 'ListAlt'
    }, {
        mime: 'text/tab-separated-values',
        ext: 'tsv',
        icon: 'ListAlt'
    }, {
        mime: 'application/vnd.ms-excel',
        ext: 'xls',
        icon: 'ListAlt'
    }, {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: 'xlsx',
        icon: 'ListAlt'
    }, {
        mime: 'application/msword',
        ext: 'doc',
        icon: 'Description'
    }, {
        mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ext: 'docx',
        icon: 'Description'
    }, {
        mime: 'video/mpeg',
        ext: 'mpeg',
        icon: 'Movie'
    }, {
        mime: 'audio/mpeg',
        ext: 'mp3',
        icon: 'Audiotrack'
    }, {
        mime: 'application/vnd.oasis.opendocument.presentation',
        ext: 'odp',
        icon: 'Slideshow'
    }, {
        mime: 'application/vnd.oasis.opendocument.spreadsheet',
        ext: 'ods',
        icon: 'ListAlt'
    }, {
        mime: 'application/vnd.oasis.opendocument.text',
        ext: 'odt',
        icon: 'Description'
    }, {
        mime: 'application/pdf',
        ext: 'pdf',
        icon: 'PictureAsPdf'
    }, {
        mime: 'application/vnd.ms-powerpoint',
        ext: 'ppt',
        icon: 'Slideshow'
    }, {
        mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        ext: 'pptx',
        icon: 'Slideshow'
    }, {
        mime: 'application/rtf',
        ext: 'rtf',
        icon: 'Description'
    }, {
        mime: 'image/svg+xml',
        ext: 'svg',
        icon: 'Image'
    }, {
        mime: 'audio/webm',
        ext: 'weba',
        icon: 'Audiotrack'
    }, {
        mime: 'video/webm',
        ext: 'webm',
        icon: 'Movie'
    }, {
        mime: 'image/webp',
        ext: 'webp',
        icon: 'Image'
    }, {
        mime: 'application/zip',
        ext: 'zip',
        icon: 'LibraryBooks'
    }
];

export default FileTypes;
